import { ref, computed } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { useHeaderStore } from '~/stores/headerStore';

export const useBodyScrollLock = (defaultValue?: boolean) => {
    const isLocked = ref(false);
    const { setHeaderStyles } = useHeaderStore();
    const { width: screenSizeWithScrollbar } = useWindowSize();
    const { width: screenSize } = useWindowSize({ includeScrollbar: false });

    const toggleLock = () => {
        const paddingRight = isLocked.value ? `${screenSizeWithScrollbar.value - screenSize.value}px` : '0';
        document.body.style.overflow = isLocked.value ? 'hidden' : 'scroll';
        document.body.style.paddingRight = paddingRight;
        setHeaderStyles({ paddingRight });
    };

    const lockScroll = computed({
        get: () => isLocked.value,
        set: (value: boolean) => {
            isLocked.value = value;
            toggleLock();
        }
    });

    if (typeof defaultValue !== 'undefined') {
        lockScroll.value = defaultValue;
    }

    return lockScroll;
};
